import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigModel} from '../models/config.model';
import { LanguageModel } from '../models/language.model';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    
    })

};

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private appConfig: ConfigModel;

  constructor(private http: HttpClient) {}

  load(): Promise<ConfigModel> {
    var promise = this.http.get<ConfigModel>('../assets/app.config.json', httpOptions).toPromise();
    promise.then(config => {
      this.appConfig = config
    });
    return promise;
  }

  getWebAPIurl(): string {
    return this.appConfig.webAPIurl;
  }

  getSignalRurl(): string {
    return this.appConfig.signalRurl;
  }

  getPlantCode(): string {
    return this.appConfig.plantCode;
  }

  getPlantName(): string {
    return this.appConfig.plantName;
  }

  getDefaultLanguage(): string {
    return this.appConfig.defaultLanguage;
  }

  getSupportedLanguages(): LanguageModel[] {
    return this.appConfig.supportedLanguages;
  }

  getDefaultDomain(): string {
    return this.appConfig.defaultDomain;
  }

  getSupportedDomains(): string[] {
    return this.appConfig.supportedDomains;
  }
}
